import store from '../store';
import Block from './Block';
// import {bindGFConfirmation} from "../util/bindGFConfirmation";

export default class InfoImages extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.progress = 0

    this.resize()
    this.formsMove();

    // // ✅ Tu peux aussi forcer le hook toi-même (si nécessaire)
    // const wrappers = document.querySelectorAll('[id^="gform_wrapper_"]');
    // wrappers.forEach(wrapper => {
    //   const formId = parseInt(wrapper.id.replace('gform_wrapper_', ''));
    //   console.log(formId);
    //   // Rebind confirmation pour formulaire 20
    //   bindGFConfirmation(formId, (confirmation) => {
    //     console.log('🎉 Confirmation form détectée !');
    //
    //     const modal = confirmation.closest('.form-modal-container');
    //     const download = modal.querySelector('.form-download');
    //     if (download) {
    //       download.classList.add("active");
    //       console.log("confirmation");
    //     }
    //   });
    // });
  }

  getElems() {
    super.getElems()

    this.wrapper = this.el.querySelector('.b-info-images__images')
    this.$images = this.el.querySelectorAll('.b-info-images__image')
    this.formTriggers = this.el.querySelectorAll('.b-info-images__item[data-modal]')
    this.forms = this.el.querySelectorAll('.form-modal-container')
  }

  events() {
    super.events();

    // Triggers pour ouvrir les modals
    this.formTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.openModal(trigger);
      });
    });

    this.forms.forEach((modal) => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          this.closeModal(modal);
        }
      });

      const close = modal.querySelector('.close-form-modal');
      if (close) {
        close.addEventListener('click', () => {
          this.closeModal(modal);
        });
      }
    });
  }

  getProgress() {
    const t = 1 - (-store.smoothScroll.scroll.instance.scroll.y + this.options.bounds.top + this.options.bounds.height) / (store.w.wh + this.options.bounds.height)

    return Math.min(Math.max(t, 0), 1)
  }

  update() {
    if (store.isMobile || !this.options) return

    const p = this.getProgress()

    if (this.progress !== p) {
      this.translate = -this.options.translate * p

      for (let i = 0; i < this.items.length; i++) {
        const {el, offset, speed} = this.items[i]
        const tX = this.translate - offset
        const r = Math.sin(tX / this.options.h)
        const y = this.options.h - Math.sqrt(Math.pow(this.options.h, 2) - Math.pow(tX, 2))

        el.style.transform = `translate3d(${this.translate * speed}px, ${y}px, 0) rotate(${r}rad)`
      }
    }

    this.progress = p
  }

  formsMove() {
    this.forms.forEach((el, i) => {
      if (el) {
        document.body.appendChild(el); // BOOM, le div sort du scroll-container
      }
    });
  }

  openModal(trigger) {
    const target = document.getElementById(trigger.dataset.modal);
    target.classList.add('active');
  }

  closeModal(form) {
    form.classList.remove('active');
  }

  resize() {
    super.resize()

    if (!this.wrapper) {
      return;
    }

    this.items = []

    const {top, height, bottom} = this.wrapper.getBoundingClientRect()

    this.options = {
      h: store.w.ww * 2.5,
      bounds: {
        top,
        height,
        bottom
      }
    }

    for (let i = 0; i < this.$images.length; i++) {
      const el = this.$images[i]
      const {left, width, right} = el.getBoundingClientRect()
      const offset = store.w.ww * 0.5 - (left + width / 2)
      const tX = offset
      const r = Math.sin(-tX / this.options.h)

      this.items.push({
        el,
        speed: el.dataset.speed,
        offset,
        right
      })

      this.$images[i].style.transform = `rotate(${r}rad)`
    }

    this.options.translate = this.items[this.items.length - 1].right - store.w.ww
  }
}
